// RouteListener.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { locationChange } from "./appRedux/actions/Setting";

const RouteListener = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(locationChange(location.pathname));
  }, [location.pathname, dispatch]);

  return null;
};

export default RouteListener;